<template>
    <div
        class="o-p-video"
        :style="componentStyles"
    >
        <video
            v-if="videoSrc"
            :autoplay="autoplay"
            :loop="loop"
            :src="videoSrc"
            :poster="poster"
            muted
            class="o-p-video_video"
            ref="OPVideo"
        >
        </video>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'OPVideo',
    computed: {
        ...mapGetters([
            'getMap',
            'getMapConfigProp'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPVideo.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPVideo.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPVideo.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPVideo.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        videoSrc() {
            const {customer_id: customerId, id} = this.getMap;
            return this.componentParams.video_src 
                || `https://fs.mvgcloud.com/static/mvg/${customerId}/maps/${id}/posters/${this.$route.params.posterId}.mp4`
        },
        loop() {
            return this.componentParams.loop
        },
        poster() {
            return this.componentParams.poster
        },
        autoplay() {
            return this.componentParams.autoplay
        }
    }
}
</script>

<style lang="scss">
@import "o-p-video";
</style>
